// extracted by mini-css-extract-plugin
export default {"projectsBoxHovered":"projectsbox_projectsBoxHovered__vgs9o","projectsBox":"projectsbox_projectsBox__l8yiL"};